import {useState} from "react";
import LessonReservationModal from "../modal/LessonReservationModal";

let EmptyCell = (props) => {
    let [modalOpen, setModalOpen] = useState(false);
    let onCloseClick = (_) => {
        setModalOpen(false);
    }

    let onCellClick = (_) => {
        if (!props.isBanned && !isDuePassed() && canMakeToday())
            setModalOpen(true);
    }
    let isDuePassed = () => {
        let dueDate = new Date(props.dateString);
        let nowDate = new Date()
        dueDate.setHours(props.hour)
        let num = (nowDate.getTime() - dueDate.getTime())

        return num >= 0;
    }
    let canMakeToday = () => {
        let dueDate = new Date(props.dateString);
        dueDate.setHours(0)
        let nowDate = new Date()
        let num = (nowDate.getTime() - dueDate.getTime())
        return props.isAdmin || num <= 0
    }
    return (
        <>
            <div
                className={"table-main-cell table-cell-lesson-empty " + (props.isBanned || isDuePassed() || !canMakeToday() ? "" : "notbanned")}
                onClick={onCellClick}>
                {props.isBanned || isDuePassed() ? null :
                    canMakeToday() ? <div className="table-empty-cell-icon"></div> : null
                }
            </div>
            <LessonReservationModal opened={modalOpen} data={props.data} dateString={props.dateString}
                                    hour={props.hour} onCloseClick={onCloseClick.bind(this)} location={props.location}
                                    teacherid={props.teacherid} setOpened={setModalOpen.bind(this)}
                                    needUpdate={props.needUpdate} isAdmin={props.isAdmin}
                                    myInformation={props.myInformation}
                                    setNeedUpdate={props.setNeedUpdate} setNeedInfoRefresh={props.setNeedInfoRefresh}
            ></LessonReservationModal>
        </>);
}
export default EmptyCell;